<template>
	<div>
		<div class="block-title">
			<span>{{labelcontainer.lable}}</span>
			<span>{{labelcontainer.desc}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Lineconbgtir",
		props: {
			labelcontainer: {
				type: Object,
				default: function() {
					return {}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.block-title {
		width: 842px;
		background: #f5f9fb;
		padding-left: 14px;
		border-left: 3px solid #1852c7;
		height: 40px;
		font-size: 20px;
		font-weight: bold;
		color: #0C0D0F;
		text-align: left;
		display: table-cell;
		vertical-align: middle;
		margin: 10px 0;

		span {
			margin-right: 20px;
		}

		span:nth-child(2) {
			font-size: 14px;
			color: #9fa5ae;
		}
	}
</style>
